var _defs, _rect, _g, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDmRateCardNumber(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 170.1 170.1",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .dummy-widget-rate-card-dm-cls-1 {\n        fill: #c1c1c1;\n      }\n\n      .dummy-widget-rate-card-dm-cls-1, .dummy-widget-rate-card-dm-cls-2, .dummy-widget-rate-card-dm-cls-3, .dummy-widget-rate-card-dm-cls-4, .dummy-widget-rate-card-dm-cls-5, .dummy-widget-rate-card-dm-cls-6, .dummy-widget-rate-card-dm-cls-7, .dummy-widget-rate-card-dm-cls-8 {\n        stroke-width: 0px;\n      }\n\n      .dummy-widget-rate-card-dm-cls-9 {\n        clip-path: url(#dummy-widget-rate-card-dm-clippath);\n      }\n\n      .dummy-widget-rate-card-dm-cls-2 {\n        fill: none;\n      }\n\n      .dummy-widget-rate-card-dm-cls-3 {\n        fill: #eaeaea;\n      }\n\n      .dummy-widget-rate-card-dm-cls-4 {\n        fill: #2f56a3;\n      }\n\n      .dummy-widget-rate-card-dm-cls-5 {\n        fill: #676767;\n      }\n\n      .dummy-widget-rate-card-dm-cls-10 {\n        opacity: .5;\n      }\n\n      .dummy-widget-rate-card-dm-cls-6 {\n        fill: #e7e6e6;\n      }\n\n      .dummy-widget-rate-card-dm-cls-11 {\n        isolation: isolate;\n      }\n\n      .dummy-widget-rate-card-dm-cls-7 {\n        fill: #fff;\n      }\n\n      .dummy-widget-rate-card-dm-cls-8 {\n        fill: #e5f4fd;\n      }\n    "), /*#__PURE__*/React.createElement("clipPath", {
    id: "dummy-widget-rate-card-dm-clippath"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "dummy-widget-rate-card-dm-cls-2",
    x: 7.2,
    y: 7.2,
    width: 155.6,
    height: 155.6
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "dummy-widget-rate-card-dm-cls-3",
    y: 0,
    width: 170.1,
    height: 170.1,
    rx: 8.4,
    ry: 8.4
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "dummy-widget-rate-card-dm-cls-9"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "dummy-widget-rate-card-dm-cls-7",
    x: 7.5,
    y: 44.6,
    width: 155,
    height: 80.6,
    rx: 6.2,
    ry: 6.2
  }), /*#__PURE__*/React.createElement("rect", {
    className: "dummy-widget-rate-card-dm-cls-6",
    x: 17.3,
    y: 102.9,
    width: 42.4,
    height: 5.5,
    rx: 2.4,
    ry: 2.4
  }), /*#__PURE__*/React.createElement("rect", {
    className: "dummy-widget-rate-card-dm-cls-6",
    x: 65.8,
    y: 102.9,
    width: 42.4,
    height: 5.5,
    rx: 2.4,
    ry: 2.4
  }), /*#__PURE__*/React.createElement("rect", {
    className: "dummy-widget-rate-card-dm-cls-6",
    x: 114.2,
    y: 102.9,
    width: 42.4,
    height: 5.5,
    rx: 2.4,
    ry: 2.4
  }), /*#__PURE__*/React.createElement("path", {
    className: "dummy-widget-rate-card-dm-cls-8",
    d: "M67.4,65.2h22.7c4.9,0,8.9,4,8.9,8.9h0c0,4.9-4,8.9-8.9,8.9h-22.7c-4.9,0-8.9-4-8.9-8.9h0c0-4.9,4-8.9,8.9-8.9Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "dummy-widget-rate-card-dm-cls-11"
  }, /*#__PURE__*/React.createElement("path", {
    className: "dummy-widget-rate-card-dm-cls-5",
    d: "M34.4,75.6c0,2.6-.5,4.6-1.6,6-1.1,1.4-2.7,2.1-4.8,2.1s-3.6-.7-4.7-2c-1.1-1.4-1.7-3.3-1.7-5.9v-3.5c0-2.6.5-4.7,1.6-6s2.7-2.1,4.7-2.1,3.6.7,4.7,2c1.1,1.3,1.7,3.3,1.7,5.8v3.5h0ZM30.6,71.8c0-1.6-.2-2.7-.6-3.4-.4-.7-1.1-1.1-2-1.1s-1.5.3-2,1c-.4.7-.6,1.7-.7,3.2v4.6c0,1.5.2,2.7.6,3.4s1.1,1.1,2,1.1,1.6-.4,2-1.1.6-1.8.6-3.3v-4.5h.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "dummy-widget-rate-card-dm-cls-5",
    d: "M45.7,75.9c-1,1-2.1,1.4-3.4,1.4s-3-.6-4-1.7-1.5-2.7-1.5-4.7.3-2.4.8-3.4,1.3-1.8,2.3-2.4,2.1-.9,3.3-.9,2.4.3,3.3.9c1,.6,1.7,1.5,2.3,2.7.5,1.2.8,2.5.8,4v1.4c0,3.2-.8,5.6-2.4,7.4s-3.8,2.8-6.7,2.9h-.9v-3.1h.8c3.3-.2,5-1.7,5.3-4.6h0ZM43.2,74.5c.6,0,1.1-.2,1.6-.5s.8-.7,1-1.1v-1.5c0-1.3-.2-2.3-.7-3s-1.1-1.1-2-1.1-1.4.3-1.9,1-.7,1.6-.7,2.6.2,1.9.7,2.5,1.1,1,2,1h0Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "dummy-widget-rate-card-dm-cls-11"
  }, /*#__PURE__*/React.createElement("path", {
    className: "dummy-widget-rate-card-dm-cls-4",
    d: "M77.6,72.8l1-1.7h1.7l-1.7,2.8,1.7,3h-1.7l-1-1.8-1,1.8h-1.7l1.7-3-1.6-2.8h1.7l1,1.7h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "dummy-widget-rate-card-dm-cls-4",
    d: "M83.2,72.8l1-1.7h1.7l-1.7,2.8,1.7,3h-1.7l-1-1.8-1,1.8h-1.7l1.7-3-1.6-2.8h1.7l1,1.7h0Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "dummy-widget-rate-card-dm-cls-11"
  }, /*#__PURE__*/React.createElement("path", {
    className: "dummy-widget-rate-card-dm-cls-4",
    d: "M86.4,71.2c0-.4,0-.8.4-1.1s.6-.4,1.1-.4.8,0,1.1.4.4.6.4,1.1v.3c0,.4,0,.8-.4,1-.3.3-.6.4-1.1.4s-.8,0-1.1-.4-.4-.6-.4-1.1v-.3h0ZM87.4,71.6c0,.2,0,.3.2.5s.3.2.4.2.3,0,.4-.2.2-.3.2-.5v-.4c0-.2,0-.3-.2-.5s-.3-.2-.4-.2-.3,0-.4.2-.2.3-.2.5v.4h0ZM88.2,76.4l-.7-.4,3.4-5.5.7.4-3.4,5.5ZM89.8,75.2c0-.4,0-.8.4-1.1.3-.3.7-.4,1.1-.4s.8,0,1.1.4.4.6.4,1.1v.3c0,.4,0,.8-.4,1s-.6.4-1.1.4-.8,0-1.1-.4-.4-.6-.4-1.1v-.4h0v.2ZM90.7,75.6c0,.2,0,.3.2.5s.3.2.4.2c.4,0,.6-.2.6-.7v-.4c0-.2,0-.3-.2-.5s-.3-.2-.4-.2-.3,0-.4.2-.2.3-.2.5v.4Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "dummy-widget-rate-card-dm-cls-4",
    points: "70.5 73.7 68.1 71.1 65.6 73.7 65.4 73.6 68.1 70.7 68.1 70.8 70.7 73.6 70.5 73.7"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "dummy-widget-rate-card-dm-cls-4",
    x: 67.9,
    y: 70.9,
    width: 0.2,
    height: 6.4
  }))), /*#__PURE__*/React.createElement("g", {
    className: "dummy-widget-rate-card-dm-cls-10"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "dummy-widget-rate-card-dm-cls-7",
    x: 7.2,
    y: -41.6,
    width: 155.6,
    height: 76.4,
    rx: 6.8,
    ry: 6.8
  })), /*#__PURE__*/React.createElement("g", {
    className: "dummy-widget-rate-card-dm-cls-10"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "dummy-widget-rate-card-dm-cls-7",
    x: 7.2,
    y: 135.5,
    width: 155.6,
    height: 76.4,
    rx: 6.8,
    ry: 6.8
  }))))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "dummy-widget-rate-card-dm-cls-1",
    d: "M155.7,125.5H14.4c-3.9,0-7.1-3.2-7.1-7.1V51.5c0-3.9,3.2-7.1,7.1-7.1h141.3c3.9,0,7.1,3.2,7.1,7.1v66.9c0,3.9-3.2,7.1-7.1,7.1h0ZM14.4,44.8c-3.7,0-6.7,3-6.7,6.7v66.9c0,3.7,3,6.7,6.7,6.7h141.3c3.7,0,6.7-3,6.7-6.7V51.5c0-3.7-3-6.7-6.7-6.7H14.4Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDmRateCardNumber);
export default __webpack_public_path__ + "static/media/dm_rate_card_number.a1389708.svg";
export { ForwardRef as ReactComponent };